module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/border-82f843583a9047b8103e1e40801b3b99.svg";